export var ICONS = {
  COINS: require("../../../assets/".concat("ti", "/images/Coin_Icon.png")),
  LOYALTY: require("../../../assets/".concat("ti", "/images/Top_Bar_Assets/Loyalty_Star_Icon.png"))
};